import { REVIEWS } from '../../lib/constants';
import { Star, Quote } from 'lucide-react';

const renderText = (text, highlight) => {
  if (!highlight) return text;
  const idx = text.toLowerCase().indexOf(highlight.toLowerCase());
  if (idx === -1) return text;
  const before = text.slice(0, idx);
  const match = text.slice(idx, idx + highlight.length);
  const after = text.slice(idx + highlight.length);
  return (
    <>
      {before}
      <mark className="bg-brand-gold/25 text-brand-cream px-1 rounded">{match}</mark>
      {after}
    </>
  );
};

export const Reviews = () => {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="section-pad bg-brand-bgElev relative overflow-hidden border-y border-brand-gold/10"
    >
      <div
        aria-hidden
        className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full opacity-20"
        style={{ background: 'radial-gradient(circle, rgba(201,169,110,0.5) 0%, transparent 70%)' }}
      />
      <div className="container-prep relative">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="eyebrow text-brand-gold mb-5">Real Reviews</p>
          <h2 className="heading-2">
            What our lash lift
            <span className="italic block text-brand-gold">clients say.</span>
          </h2>
          <div className="flex items-center justify-center gap-2 mt-6">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={18} className="fill-brand-gold text-brand-gold" />
              ))}
            </div>
            <span className="text-brand-muted text-sm">3,311+ verified reviews</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <article
              key={r.name}
              data-testid={`review-${i}`}
              className={`bg-brand-bg border border-brand-gold/15 rounded-3xl p-8 hover:border-brand-gold/40 hover:bg-brand-bgSoft transition-all ${
                i === 2 ? 'lg:row-span-2 lg:bg-brand-gold/10 lg:border-brand-gold/40' : ''
              }`}
            >
              <Quote size={28} className="text-brand-gold/60 mb-4" />
              <div className="flex mb-4">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} size={14} className="fill-brand-gold text-brand-gold" />
                ))}
              </div>
              <p className={`text-brand-cream/90 leading-relaxed mb-6 ${i === 2 ? 'lg:text-lg' : ''}`}>
                "{renderText(r.text, r.highlight)}"
              </p>
              <div className="pt-5 border-t border-brand-gold/15">
                <div className="font-medium text-brand-cream">{r.name}</div>
                <div className="text-xs text-brand-muted uppercase tracking-wider mt-0.5">
                  {r.source} · {r.date} · Vancouver
                </div>
              </div>
            </article>
          ))}
        </div>

        <p className="text-center mt-14 text-brand-muted italic font-serif text-xl">
          Join 3,300+ happy clients at Prép Beauty Parlour — Vancouver's
          <span className="text-brand-gold"> most-reviewed </span>
          lash studio.
        </p>
      </div>
    </section>
  );
};

export default Reviews;
